export enum TriviaGameCategory {
  Standard = 0,
  Themed = 1,
  Kid_Friendly = 2,
  XXX_Rated = 3,
  Corporate = 4,
  Custom = 5,
  TriviaMatic_Manager_Custom = 6,
}
